export const croAccountingConstants = {
    RESET: 'RESET',
    CROACCOUNTING_FETCHING: 'CROACCOUNTING_FETCHING',
    CROACCOUNTING_FETCHED: 'CROACCOUNTING_FETCHED',
    CROACCOUNTING_SUBMITTING: 'CROACCOUNTING_SUBMITTING',
    CROACCOUNTING_SUBMITTED: 'CROACCOUNTING_SUBMITTED',
    GET_VOYAGE_LIST_CRO_ACCOUNTING: 'GET_VOYAGE_LIST_CRO_ACCOUNTING',
    GET_WAYBILL_LIST_CRO_ACCOUNTING: 'GET_WAYBILL_LIST_CRO_ACCOUNTING',
    GET_WAYBILL_CRO_ACCOUNTING: 'GET_WAYBILL_CRO_ACCOUNTING',
    GET_CRO_ACCOUNTING_BY_ID: 'GET_CRO_ACCOUNTING_BY_ID',
    GET_VOYAGE_DESTINATION: 'GET_VOYAGE_DESTINATION',
    GENERATE_WAYBILL_INVOICE: 'GENERATE_WAYBILL_INVOICE',
    CRO_POST: 'CRO_POST',

    // PDC CLearing
    LOAD_PDC_COLLECTION: 'LOAD_PDC_COLLECTION',

    // BASE Manual SI
    MANUAL_SALES_INVOICE: 'MANUAL_SALES_INVOICE',
    MANUAL_SALES_INVOICE_OTHER: 'MANUAL_SALES_INVOICE_OTHER',
}